import { BaseQueryFn, createApi, FetchArgs, fetchBaseQuery, FetchBaseQueryError } from '@reduxjs/toolkit/query/react'
import { ENDPOINTS } from '@constants/index'
import { AuthToken, AuthTokenArgs } from '@typesApp/Session'
import { config } from '@config/config'
import { dbPrepareHeaders } from './prepareHeaders'

const authBaseQuery: BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError> = async (
  args,
  api,
  extraOptions
) => {
  const dbBaseQuery = fetchBaseQuery({
    baseUrl: config.getApiHost(),
    prepareHeaders: dbPrepareHeaders,
  })
  return await dbBaseQuery(args, api, extraOptions)
}

export const authApi = createApi({
  reducerPath: 'auth',
  baseQuery: authBaseQuery,
  keepUnusedDataFor: 300,
  endpoints: builder => ({
    getAuthToken: builder.mutation<AuthToken, AuthTokenArgs>({
      query: body => ({
        url: ENDPOINTS.DIRECT_BILLING.AUTH_TOKEN,
        method: 'POST',
        body,
      }),
    }),
  }),
})

export const { useGetAuthTokenMutation } = authApi
